import PropTypes from "prop-types";
import {useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
// @mui material components
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbarLink from "examples/Navbars/DefaultNavbar/DefaultNavbarLink";
import { useEffect } from "react";

function DefaultNavbarMobile({ open, close }) {
  const { width } = open && open.getBoundingClientRect();

  const { language, changeLanguage } = useContext(LanguageContext);

  useEffect(() => {
    const storedLang = localStorage.getItem("language");
    if (storedLang) {
      changeLanguage(storedLang);
    }
  }, [changeLanguage]);

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    changeLanguage(newLang);
  };

  return (
    <Menu
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      anchorEl={open}
      open={Boolean(open)}
      onClose={close}
      MenuListProps={{ style: { width: `calc(${width}px - 4rem)` } }}
    >
      <MDBox px={0.5}>
        <DefaultNavbarLink icon="account_circle" name="sign up" route="/authentication/sign-up" />
        <DefaultNavbarLink icon="key" name="sign in" route="/authentication/sign-in" />

        {/* 語言切換下拉選單 */}
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel id="mobile-language-select-label">語言-Language</InputLabel>
          <Select
            labelId="mobile-language-select-label"
            id="mobile-language-select"
            value={language}
            label="語言-Language"
            onChange={handleLanguageChange}
            size="small"
            sx={{height:"2em",}}
          >
            <MenuItem value="zh-TW">繁體中文</MenuItem>
            <MenuItem value="zh-CN">简体中文</MenuItem>
            <MenuItem value="en">English</MenuItem>
          </Select>
        </FormControl>
      </MDBox>
    </Menu>
  );
}

// Typechecking props for the DefaultNavbarMenu
DefaultNavbarMobile.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
};

export default DefaultNavbarMobile;
